import { useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { useLang } from "@/context/LangContext";

export default function SeatPicker({ seats, selected, onPick }) {
  const [open, setOpen] = useState(false);
  const { t, lang } = useLang();
  const ta = lang === "ta";
  const current = seats.find((s) => s.ac_no === selected);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className={`w-full flex items-center gap-2 rounded-full bg-white px-4 py-3 text-left text-[14px] text-[#1a1640] search-shadow ${ta ? "font-tamil" : ""}`}
          data-testid="map-seat-picker"
        >
          <Search size={16} className="text-[#8c89ad]" />
          <span className="flex-1 truncate">{current ? (ta ? current.name_ta : current.name) : t("search_seat")}</span>
          <ChevronsUpDown size={15} className="text-[#8c89ad]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)]" align="start">
        <Command>
          <CommandInput placeholder={t("search_seat")} data-testid="map-seat-picker-input" />
          <CommandList className="max-h-72">
            <CommandEmpty>—</CommandEmpty>
            {seats.map((s) => (
              <CommandItem
                key={s.ac_no}
                value={`${s.name} ${s.name_ta} ${s.district} ${s.ac_no}`}
                onSelect={() => { onPick(s.ac_no); setOpen(false); }}
                data-testid={`map-seat-option-${s.ac_no}`}
              >
                <Check size={14} className={s.ac_no === selected ? "opacity-100" : "opacity-0"} />
                <span className={ta ? "font-tamil" : ""}>{ta ? s.name_ta : s.name}</span>
                <span className="ml-auto text-[11px] text-[#8c89ad]">{s.district}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
